export default "__VITE_ASSET__B9iM1gsT__"